import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';
import Nora from '@primeng/themes/nora';
import Aura from '@primeng/themes/aura';
import Material from '@primeng/themes/material';

const BussifyPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '{sky.50}',
      100: '{sky.100}',
      200: '{sky.200}',
      300: '{sky.300}',
      400: '{sky.400}',
      500: '{sky.500}',
      600: '{sky.600}',
      700: '{sky.700}',
      800: '{sky.800}',
      900: '{sky.900}',
      950: '{sky.950}',
    },
    surface: {
      ground: '{gray.50}',
      card: '#ffffff',
      overlay: '#ffffff',
      border: '{gray.200}',
    },
    text: {
      color: '#0f172a',
      colorSecondary: '#64748b',
    },
    highlight: {
      bg: '#e2e8f0',
      textColor: '#0f172a',
    },
    maskbg: 'rgba(15, 23, 42, 0.55)',
    focusRing: '0 0 0 2px rgba(59, 130, 246, 0.35)',
    shadow: '0 1px 2px 0 rgba(15, 23, 42, 0.08)',
  },
});

export default BussifyPreset;
